// Batch 2 livestock, feed, inventory, health, and lifecycle UI catalogs.
export const batch2En = {
  "0105252023c5": "Unit Cost",
  "018514a3d58a": "Timeline",
  "01a8dd48c500": "Barcode / QR",
  "01e479028989": "Pedigree (3 generations)",
  "023d1181ebc6": "Low Stock",
  "032febbbb012": "Save Consumption",
  "037dc426fbbd": "Sick Animals",
  "05cc931fe63d": "Create a new livestock species. You can add custom fields and formulas from Admin Settings after.",
  "060be00f4f26": "All categories",
  "079bd7775895": "Siblings (",
  "07e6e386d87a": "Est. Value",
  "080a39596b61": "Livestock AI Insight",
  "096e170e0991": "Newborn",
  "099f73ce4905": "Pick an animal",
  "0a06508c0175": "Sale Record",
  "0a69d61b0b25": "Lookup code",
  "0a93bd3c4443": "No feed stock items are below reorder level.",
  "0b06e22a7e19": "No warehouse locations yet",
  "0be720759ff0": "Revoke",
  "0c8309d1f4d0": "Download PNG",
  "0cf263a1c25f": "Feed batches are represented by stock items with batch numbers and expiry dates.",
  "0d51eeffd436": "Total stock items",
  "0efc2e6be4c2": "Overview",
  "10dc5cb22bb7": "No feed consumption yet",
  "10de46b3b341": "Certificate",
  "116ccb175621": "sales linked.",
  "118c99e6d6da": "Select feed",
  "11a1827a2b21": "drag an animal card between columns to move life stages. Sale-readiness blocks unsafe moves.",
  "1389845b02c0": "kg",
  "13b9bfe85a7b": "Active Animals",
  "143b179529ae": "Custom Fields",
  "145f77316273": "Choose QR on any row to preview a scannable code.",
  "156310055287": "vaccination(s) overdue — check individual animal profiles.",
  "1608ccdc1cab": "Average cost / kg",
  "1615009c340b": "Manager approve for sale",
  "1675280ca24d": "No records match the selected filter.",
  "179ac1a75869": "Select animal",
  "17d97685ac11": "Min sale age (d)",
  "18316e7e2a76": "No expiring feed items found.",
  "195728a9d22b": "Feed Since Previous",
  "19647db2fbfa": "animals",
  "19ddafc12f92": "Tools Inventory",
  "1a66279d9648": "https://…",
  "1a7b7c1b33d1": "Transaction",
  "1a9fa345cfd3": "Feed Categories",
  "1bf3994417be": "Location:",
  "1c26dccca4ec": "Monthly feed usage:",
  "1c54132b8e5a": "Record",
  "1c5a564d4c4d": "No feed purchases yet",
  "1d0c73d85f54": "Warehouse Locations",
  "1e1856a908fb": "Item, SKU, supplier, location...",
  "1e5ff9e500c2": "Qty",
  "1e75cf7a0372": "Stock Movement History",
  "1eb4012ee2c9": "New Births",
  "1ee3200b888b": "Comma-separated values",
  "1f85f16afefa": "FCR",
  "201c869f726a": "Health Checks",
  "201cf44b6094": "Live totals for feed stock, purchases, consumption, and alerts.",
  "203b14a9d303": "Loading animal records…",
  "2044b2d32473": "Medicine, equipment, tools, asset register, warehouse locations, stock history, and QR support in one live workspace.",
  "20e338624cee": "Assets",
  "22d5a3425998": "Add Animal",
  "22dbc070acdf": "Vaccination",
  "23101365c88a": "Record Weight",
  "232dc1368f6e": "To Location",
  "234d8d89d396": "Gestation Days",
  "237a3b253245": "Loading growth records...",
  "246d291dae87": "Total Feed",
  "257fe95db51c": "No timeline events yet.",
  "25b2f1c9237e": "Sale-Readiness Checklist",
  "25c278896313": "No animals available",
  "260ff50a7c28": "All Animals",
  "275a700078f0": "record",
  "2868023ccc42": "Log current weight and feed consumed since last weigh-in.",
  "2893ab3bd846": "Health Records",
  "295c43d41882": "Latest Weight",
  "29bbaabc2052": "Acquisition Date",
  "2a6c6b93fb28": "Father (Sire)",
  "2bee5f4a4c10": "No movement history",
  "2d2a1342f45d": "Next Service Date",
  "2d812736dca6": "Every animal from birth to sale — current life stage, sale readiness, health & mortality.",
  "2e123d865f03": "Feed supplier names appear automatically from feed stock and purchase orders.",
  "2e71a937eb6d": "Health Inspections",
  "2ebeb6a45fe0": "No feed consumption records yet",
  "2ee750e04190": "Tip:",
  "2ee822bf17dd": "Births (Month)",
  "2eed73e61b10": "Generate Barcode",
  "2f4979324e03": "Condition",
  "2f7b242e3a83": "Species Presets",
  "300d29fd5f32": "Inventory",
  "3030076c7bc2": "No feed movements yet",
  "304918a345d2": "Manager approve",
  "30c3a17c5a54": "Total records",
  "30c8a0fc9c1a": "All types",
  "325760e748ec": "Weight Summary",
  "3281188351b8": "CSV",
  "3333d041a6de": "Configure species-specific livestock fields that appear in animal forms and profile records.",
  "33ce417454bf": "Loading…",
  "33d9978c4477": "Reorder",
  "33f147e5a87f": "e.g. spoilage, correction, transfer",
  "34290c48ee0b": "e.g. Buffalo, Turkey…",
  "3467859735eb": "Track tools, cleaning supplies, and consumable support stock here.",
  "346c87feb190": "Breed:",
  "349ac8fb67f7": "Select…",
  "36155d48f460": "Equipment",
  "36da837e8b37": "Medication",
  "3700890937a4": "Item *",
  "3703cd216881": "Health",
  "37dcaa9ab12f": "Gain/Loss",
  "381c4bf1d409": "Clear Filters",
  "382bc33f5991": "Growth Curve",
  "394f35e11401": "M-Grandma",
  "395703d5f5b9": "Previous Weight",
  "396c65e60e58": "Supplier *",
  "398658a601d9": "remaining",
  "3aa9bacb43a2": "Feed Suppliers",
  "3b906ae77c48": "— None —",
  "3c40a44bb41f": "Inventory Management",
  "3ca127a5a35d": "Track weight, feed consumption, average daily gain, and feed-conversion ratio.",
  "3d0aa2fbc3ed": "Save Weigh-in",
  "3d9f454fe3cd": "Option A, Option B",
  "3dcb2be9fa88": "Could not load Inventory Management",
  "3deb74565196": "Type",
  "3eb1b2e6c5fb": "Add medicine or vaccine items to start tracking storage, stock, and expiry.",
  "3f3a489c72de": "Male",
  "3f3cc34fc78f": "animal(s) under active treatment / observation.",
  "3f82cd24f99b": "Completed Schedules",
  "3f87a11da0d1": "₱ / kg",
  "40aa5a2268dc": "Feed deductions, receipts, and adjustments will appear here.",
  "40e64b44039a": "M-Grandpa",
  "4208adadecd9": "Target weight (kg)",
  "439e231109dc": "Order Date",
  "43aa47469f02": "Vaccinations completed",
  "43c8e26ef9d3": "Record Consumption",
  "43e861b50e09": "Animal QR Tag",
  "4426afd90a77": "Asset",
  "44d25b5d1b6d": "Items",
  "44ef3f997add": "Photo Gallery",
  "44f6af694554": "Quantity",
  "4526beb53b60": "Analyzing animal profile...",
  "45e73b4ba97d": "Feed Purchase",
  "45e7a1c379c7": "QR",
  "460faa8a18da": "Storage locations are derived from item records as you add them.",
  "46f9990edd2b": "Open Species Setup",
  "479ad150d354": "Tag ID *",
  "49181eaa9abb": "No animals match the current filters.",
  "493a215189e8": "Add farm assets to track status, condition, and service dates.",
  "49e21486cc6e": "Manage Species",
  "4a26dca78564": "Status Breakdown",
  "4a9db9b99989": "Record Weigh-in",
  "4bf117c4c02d": "No active animals in this species filter.",
  "4c669e0b6268": "Quantity (kg)",
  "4c8f26e7117b": "Pen / Housing",
  "4cbdfa3a77db": "Feed (kg)",
  "4d56ca9be0c8": "Notes (optional)",
  "4e579c31017e": "Assets registered",
  "4e836fdc2572": "Manual",
  "4ec763aab4f8": "Feeding",
  "4f647c1b1ab2": "Back to Species",
  "4fa548ec107d": "Search timeline events...",
  "4fa8cc860c52": "Tools",
  "5006ed0248a0": "event",
  "509e9a0f3232": "No active livestock notifications.",
  "512dad105fdd": "Dropdown Options",
  "51488472c352": "Record consumption to update stock and cost tracking.",
  "515dd86c51f4": "Pregnancy Checks",
  "52526afc1060": "Overall FCR",
  "5301648dcf6b": "Edit",
  "5332fb07ad51": "All Inventory Items",
  "534f84da47a2": "Animal Registry",
  "5397e0583f14": "Yes",
  "541c79d8906d": "Growing / Fattening",
  "54bce5904e5b": "Source Options",
  "54bf2f40c6da": "Monthly medicine usage:",
  "5548ae4f34cb": "days",
  "55edd462872a": "Supplier",
  "55f9626c6c05": "Add Field",
  "56e3badc4e6c": "Refresh",
  "57162c35dea4": "Name*",
  "5755f9ac0aa1": "Export CSV",
  "585c19860651": "Breeding & Gestation AI Insight",
  "58b9f51cadf2": "Feed Runway & Reorder Insight",
  "58c0bd6ade68": "Use the lookup field to find an inventory item or asset by code or name.",
  "59bba0608a3c": "Next Due / Follow-up",
  "59ef31e37acc": "Reorder Level",
  "5b221e9c2a45": "Print",
  "5b4a40f54485": "Farrowing",
  "5b779ea02219": "Allow negative stock (owner/admin only)",
  "5b83c8c1f5d4": "Medical Timeline Records",
  "5baa9155c930": "Feed Cost Tracking",
  "5bdd5c241b30": "Birth-to-Sale",
  "5c173ef78781": "Select species",
  "5c5ad63cd148": "Add Gestation",
  "5cbf60902ee2": "Gestation",
  "5d08f9511d95": "Rows:",
  "5d1b80121622": "Monthly Feed Cost",
  "5d6b50bb295d": "Gain Since Previous",
  "5dde525d8086": "Total Animals",
  "5e5837db8186": "Total Gain",
  "5fb4a01bf140": "Cost / Unit",
  "6051a9526ec0": "records for this species.",
  "6083e706b22f": "Piglet / Young",
  "60f1e913db61": "Not specified",
  "6149ff653a46": "Daily Gain",
  "61b5b59fbab8": "Offspring (",
  "61cc55aa0453": "Add",
  "62096e1d4d84": "P-Grandma",
  "6405179d241b": "All statuses",
  "64257ac78d08": "Location Labels",
  "6451a93db098": "Vet visit",
  "64ae43e8fe76": "Cost",
  "64b69a9e55a0": "Pen, pond, coop, cage…",
  "6527e706017d": "ADG",
  "6600f853ec41": "Production Stage",
  "67a6ff10f1b9": "Reserved",
  "68309f127cb6": "Move blocked",
  "687c82861c95": "Documents",
  "699edf83caae": "Blockers",
  "69bd4ef9fbd0": "View",
  "69c0b81540bd": "Weight",
  "6ad8acc1a379": "Medicine Inventory",
  "6b7c0218276d": "Sex Options",
  "6bccca646f67": "Deducted",
  "6c7dc36d0d76": "Medical Alerts",
  "6da13addb000": "Source",
  "6e48b29888d5": "Breed Options",
  "6e6a6f2086bb": "Other",
  "6eef6648406c": "None",
  "6f62975f8e77": "Average Weight",
  "7015ab4fc4ea": "Lookup",
  "70440046a3dc": "Notes",
  "709a23220f2c": "Name",
  "70b6f53fbdf9": "No weigh-ins yet for this animal. Click \"Record Weight\" to start tracking.",
  "716f63b96e0c": "Icon",
  "7175a9fe5560": "Purchase orders and receiving flow for feed suppliers.",
  "71ae2e313d19": "Save Field",
  "71d6ab175c7f": "Animal ID",
  "72190121658b": "Current Weight (kg)",
  "725bc458ce08": "Sale Readiness",
  "725d63c76780": "Create medicine, equipment, or tool stock to start tracking.",
  "73656b6dcc12": "Price / kg",
  "7389b3b752fa": "Animal",
  "74341e3c271d": "Label",
  "7451228fe603": "Auto-generated if blank",
  "7477762fadeb": "Use negative for reduction",
  "747876156da0": "Purchase Cost",
  "76e4488c60b0": "Total value:",
  "77074b7e37f0": "Livestock Notifications",
  "777c078c9b7b": "Breed",
  "7794d275d6c6": "Add Pregnancy Check",
  "77dfd2135f4d": "Cancel",
  "780b2eb08d06": "No events match your filters.",
  "78b819622818": "New Item",
  "797a4917230e": "All locations",
  "79ec1b992c03": "Record consumption to deduct stock and track feed cost per kg.",
  "7ac5949949ba": "New Species",
  "7b83bbb85e1b": "Record Stock Transaction",
  "7b95b5178611": "Vaccinations",
  "7cc6e4582b56": "No photos linked.",
  "7cd5b9ea84fa": "Field Key",
  "7d7bb74219c3": "Breeding Stock",
  "7d9252d939e7": "Equipment Inventory",
  "7db486db207f": "Generate QR",
  "7e5a975b6add": "Identity",
  "7e8892b35c5f": "Select an item or asset",
  "7ec2484371b6": "Mortality (Month)",
  "7f606a9b1522": "No medicine inventory",
  "80029aac6ba4": "Add Deworming",
  "80e519ac864e": "Monthly Gain",
  "816c52fd2bdd": "No",
  "83800502d070": "Loading feed inventory...",
  "83a56249e5cf": "Attachment",
  "83a7238826ab": "Species",
  "84d296628caf": "Expected Date",
  "84dfdb55f9e6": "Photo URL",
  "86b217fdcad3": "Batch Number",
  "87398e24ea58": "Health checks",
  "88bc3fe3dadd": "Reports",
  "896a4e836ceb": "Feed Inventory",
  "8a7e05ab4689": "Could not load Feed Inventory",
  "8ac44bc6683d": "Read-only asset register",
  "8b42192e439b": "Universal Livestock",
  "8b7cad5bca5b": "Under Treatment",
  "8b8331402853": "No feed stock yet",
  "8bf1ef5668b1": "Batch",
  "8c603960eb2f": "No species yet.",
  "8d007050838a": "Expiry Date",
  "8dce170de238": "Value",
  "8df6fbb79f88": "Expiry alerts",
  "8f210c7b2cfe": "This animal",
  "8f57e24b53b0": "Gestation (days)",
  "8fabfed883f0": "Inventory Barcode",
  "8fba6b663578": "Next Service",
  "9020d87d6a1d": "No species configured yet",
  "90fb871e3532": "Warehouse locations",
  "911f3b0b4732": "You're moving this animal to",
  "915586ea1401": "Cost Breakdown",
  "9277a4e58ef5": "Add Breeding",
  "92928c7b6205": "No rows for this report.",
  "92a72cdc19c4": "Select stage",
  "931b0211b3e6": "Minimum Stock",
  "931cd0b708ee": "Current Weight",
  "93ccf8886685": "Receiving, feeding deductions, and manual adjustments appear here.",
  "965fb2ddf63d": "Receive",
  "96f84c4f4b2d": "Animal ID / Tag",
  "97c89a4d6630": "Action",
  "9815c7072808": "Pick animal",
  "982963c1c41c": "Tag",
  "98e5ef062b2a": "Download PDF",
  "995d09d416ac": "Record Feed Consumption",
  "9978c7eb8d75": "No birth record linked to this animal.",
  "9a4352f7fb4a": "No assets registered",
  "9ae2c512e27d": "No equipment inventory",
  "9afdc0c98e0e": "Transaction Type *",
  "9c3befe7e22c": "Notes:",
  "9c59b3b940b8": "No inventory items",
  "9cc46760be1f": "checks passed",
  "9d2c70630887": "Identification",
  "9daa9201229d": "Cost/Unit",
  "9df4ffaba1bc": "Review Alerts",
  "9e883160f12a": "d old",
  "9f5cd8a2e880": "Retry",
  "9fdae79fc41c": "Could not load Animal Registry",
  "a05f378cba73": "Due Vaccinations",
  "a08e11119aef": "Excel",
  "a10cf6a84db4": "No category data available.",
  "a124947cbd2d": "Low",
  "a225c8ebcac0": "Storage Location",
  "a29d47a9717b": "Feed Purchases",
  "a3081da3685d": "Create purchase orders for feed replenishment and receive them into stock.",
  "a3c686e711e4": "Category",
  "a3f812e5f85c": "Save Transaction",
  "a4cbd21f4a3d": "Delta",
  "a65de8bce998": "Assigned Area",
  "a689a999a5e6": "Expired",
  "a6989f1caddd": "Birth Date",
  "a6e1fef14e1b": "Low stock",
  "a733b809d2f1": "Active",
  "a7502c1c8415": "Mother (Dam)",
  "a7fc7eb3b9ba": "Lookup Result",
  "a9001c7bea7d": "AI advisory only. Verified inventory records, stock deductions, runway calculations, and reorder rules remain authoritative.",
  "a91f9527fb14": "No animals yet. Add your first!",
  "aa68ea8175f6": "Search SKU, item name, asset QR, or asset name",
  "aada71c46f1c": "No feed batches yet",
  "ac5932b6433e": "Operational Snapshot",
  "ad43a5186744": "Add Species",
  "ad87109bfff0": "empty",
  "ada52d888ccf": "Sources:",
  "ae0433b83254": "Pregnant Animals",
  "ae2279147e20": "Search animal ID, tag, breed, species…",
  "ae65324b857d": "Farm Operations",
  "aebda3645d67": "Select feed item",
  "aee5f633d5df": "Kg",
  "af59c1b5032c": "Save Feed Purchase",
  "afda12b73a18": "Add a feed stock item and assign a category to begin grouping inventory.",
  "afe080d91852": "No tools inventory",
  "b0025fcfba1a": "Print Tag",
  "b04ba49f8486": "Loading...",
  "b0946c471bef": "Select item",
  "b19f1a5a771a": "Feed Stock",
  "b2107cb53b71": "You can view the asset register, but asset edits require settings permission.",
  "b2537e92cedd": "· reorder",
  "b25928c69902": "Total",
  "b25db9c91647": "ADG (kg/day)",
  "b298bc6a9e73": "Vaccinations Due",
  "b2d28451f2ac": "Inventory consumption:",
  "b37bfabd815c": "Tap a species to see its dashboard, records, inventory, sales & health.",
  "b452abc00d55": "Low Stock Alerts",
  "b5d8da40f3ed": "Total Cost",
  "b6321aaca189": "Field Type",
  "b6a5b27dc1c9": "Current feed stock value",
  "b7c17e97d3d6": "Female",
  "b7caebb3a0d2": "No photo",
  "b7f1480271f7": "Growth & FCR",
  "b8273ffd22de": "Upcoming Schedules",
  "b8fde823cc69": "Feed Category",
  "b92e64f8b332": "Select...",
  "b9379d305ca4": "Feed Consumption",
  "b953668f0a6d": "Approved by",
  "b98d67213b38": "Expiring",
  "b9b664eafeff": "Livestock Performance",
  "ba30f581b71a": "No feed categories yet",
  "ba8f571e0f93": "Expiry",
  "bae7d5be7082": "Status",
  "bb4b09092c7b": "Market Ready",
  "bb6b3d02e567": "Filter by species",
  "bb98ca672621": "QR Preview",
  "bbfa773e5a63": "Close",
  "bc08c8ca11eb": "Loading species and animals...",
  "bc23d3365489": "Recent Feed Movements",
  "bc2bbcfd991a": "Active cases",
  "bc67a8aefae6": "Out of Stock",
  "bce06414177f": "Search",
  "bcecf4562f17": "Stock",
  "be2218931154": "Upload Documents",
  "be52964f94d6": "One configurable system for pigs, cattle, poultry, fish, pets, bees, and custom species.",
  "c0d66da0ed20": "but sale-readiness checks are failing:",
  "c0f789c54889": "Add Vaccination",
  "c195df524d2c": "Growing / Finishing",
  "c26b31168973": "Total Production Cost",
  "c3cd636a585b": "Actions",
  "c40810f5c31d": "Quick Actions",
  "c425df01c7ec": "Search tag, name, breed...",
  "c4506f67727e": "Force move anyway",
  "c500690deb24": "All species",
  "c63acbcc4830": "Status Options",
  "c6cdc5b935cb": "Save Species Config",
  "c813d87308e6": "Livestock Pipeline",
  "c81b853cafb4": "Inventory Item",
  "c8899e40dced": "Save Feed Stock",
  "c9411ae8d103": "Ready for Sale",
  "ca567dda33cd": "Code:",
  "ca6d0e3aaa7d": "Stage",
  "cd8c2df26c59": "Medicine",
  "cded093321dd": "Orders",
  "ce31372bab62": "Sale-Readiness",
  "cf6c07e7054f": "Pen",
  "cfadbd7a5771": "By",
  "d03becf78c55": "e.g. Started new feed formula",
  "d07a4554e6f9": "Loading report...",
  "d0940f026be6": "Add Medication",
  "d0edfb6e8c55": "Sales",
  "d0efe0b2c75c": "Alerts",
  "d145bb830936": "Name *",
  "d17858483509": "Livestock",
  "d219c68101f5": "Location",
  "d24983206285": "Weight (kg)",
  "d356631d4242": "Asset Register",
  "d43c8e6c0c7e": "Employee/User",
  "d53879f401fe": "Weight:",
  "d59192b9c8f2": "SKU",
  "d613d88cb2d8": "PDF",
  "d65ae9967727": "QR / Barcode",
  "d6dadec06672": "Receipts",
  "d758262e8fe0": "Loading inventory management...",
  "d7d33a37498a": "Feed Since Last (kg)",
  "d82998b02298": "No match yet",
  "d87f47b47e4d": "Dashboard",
  "d8b4d943f628": "Species Config",
  "d8b795f1caa9": "Livestock Hub",
  "d8c57bebe4be": "Recent Consumption",
  "d96f52b84799": "Inventory Value",
  "dab547ca0781": "Overdue Schedules",
  "db3d405b1067": "on",
  "db772d77f026": "Feed Batches",
  "dcbe6782d317": "Monthly feed cost",
  "dcf09d387818": "Sold (Month)",
  "dd5f667597ac": "Stock by Category",
  "decd7ca80010": "Latest",
  "df4ebc16e8c5": "Batch / Expiry",
  "df9c88127462": "Deworming",
  "e0a94b30808d": "No custom fields for this species yet.",
  "e154cb584579": "Target Weight",
  "e1d599cca0a1": "Add at least one species before creating animal records.",
  "e1dee3f10e02": "From Location",
  "e301dd6062f7": "Sex",
  "e3c2f30bf6f0": "Weight Progress",
  "e49000cd16ad": "No preview",
  "e51c55255be9": "Records",
  "e57310bd5fa4": "Schedule Vaccination",
  "e5af0395ec56": "Sex:",
  "e6560d9c298e": "Sold",
  "e82e5b2a7359": "Movement records",
  "e838aabe4ef1": "Feed Item *",
  "e997447a5ce9": "Warehouse Location",
  "e9da79148e64": "Due / follow-up alerts",
  "e9fd92ae6da3": "Feed categories, suppliers, purchases, batches, stock, consumption, and live alerts in one production view.",
  "ea0e082d4d4b": "Save Item",
  "ea43c011ff1e": "Track equipment parts and replacement stock here.",
  "ea8cd0b9a0bd": "Schedule Treatment",
  "eb9a4bc1c0c1": "Date",
  "ecdda59aea5e": "Item",
  "ed8cb2617ecd": "Add Farrowing",
  "ee45c30326b7": "Report",
  "eebf5dd44b08": "No weight measurements yet.",
  "eed6bfb41051": "Required",
  "ef2c495072dd": "New Weight",
  "ef3b54d66fd8": "Add Vet Visit",
  "f13fa3438318": "Deceased",
  "f20905eeec4b": "Create the first feed inventory item to start tracking stock and consumption.",
  "f219cc0614ae": "Reason",
  "f22e1c3983ce": "New Feed Stock",
  "f28563a477a9": "Colour",
  "f2c6b564bd81": "Section",
  "f32eebfabdfe": "Consumption entries",
  "f4d52fad548f": "Total Alive",
  "f4ec66c8df43": "Gestation:",
  "f50d3e648add": "Current feed items, batch details, stock levels, and costs.",
  "f588d982d308": "Species Breakdown",
  "f6b935ab3371": "Unit",
  "f6ce3b6fcfca": "Receipt",
  "f6d8dc2e9c7a": "Expiry Alerts",
  "f6fdbe48dc54": "Delete",
  "f76d1e2a5054": "Transferred",
  "f7aaca979af6": "Stock Summary",
  "f9096ddd8468": "Add Health Check",
  "f93f25f348f3": "Breeding",
  "f967a88e008c": "No suppliers yet",
  "f97872e1cdbb": "P-Grandpa",
  "f9c10dfc68e6": "🤖 AI Insight",
  "fbfb66c84913": "Mortality",
  "fc78ebe76aec": "Feed Name *",
  "fcf1dded7a2a": "With media",
  "fd3bc9709730": "Backend-linked summary",
  "fe5220666fae": "Pen / Location",
  "ff18d709fc9e": "Feed items",
  "ff1928e5d29b": "Feed",
  "ff4fc0276e96": "Profile",
  "ffc91ed29d9d": "Save Asset"
};

export const batch2Tl = {
  "0105252023c5": "Gastos Bawat Unit",
  "018514a3d58a": "Timeline",
  "01a8dd48c500": "Barcode / QR",
  "01e479028989": "Pedigree (3 henerasyon)",
  "023d1181ebc6": "Mababang Stock",
  "032febbbb012": "I-save Consumption",
  "037dc426fbbd": "Sick Mga Hayop",
  "05cc931fe63d": "Create a new livestock species. You can add custom fields and formulas from Admin Settings after.",
  "060be00f4f26": "Lahat ng kategorya",
  "079bd7775895": "Siblings (",
  "07e6e386d87a": "Est. Halaga",
  "080a39596b61": "Livestock AI Insight",
  "096e170e0991": "Bagong Panganak",
  "099f73ce4905": "Pumili ng hayop",
  "0a06508c0175": "Sale Tala",
  "0a69d61b0b25": "Paghahanap code",
  "0a93bd3c4443": "Walang feed stock items are below reorder level.",
  "0b06e22a7e19": "Walang warehouse locations yet",
  "0be720759ff0": "Revoke",
  "0c8309d1f4d0": "I-download ang PNG",
  "0cf263a1c25f": "Pakain batches are represented by stock items with batch numbers and expiry dates.",
  "0d51eeffd436": "Kabuuang stock items",
  "0efc2e6be4c2": "Buod",
  "10dc5cb22bb7": "Walang feed consumption yet",
  "10de46b3b341": "Certificate",
  "116ccb175621": "sales linked.",
  "118c99e6d6da": "Pumili feed",
  "11a1827a2b21": "drag an hayop card between columns to move life stages. Sale-readiness blocks unsafe moves.",
  "1389845b02c0": "kg",
  "13b9bfe85a7b": "Mga Aktibong Hayop",
  "143b179529ae": "Mga Custom Field",
  "145f77316273": "Piliin ang QR sa anumang row upang makita ang scannable code.",
  "156310055287": "vaccination(s) overdue — check individual hayop profiles.",
  "1608ccdc1cab": "Karaniwang gastos / kg",
  "1615009c340b": "Manager approve for sale",
  "1675280ca24d": "Walang records match the selected filter.",
  "179ac1a75869": "Pumili animal",
  "17d97685ac11": "Pinakamababang edad para ibenta (araw)",
  "18316e7e2a76": "Walang expiring feed items found.",
  "195728a9d22b": "Pakain Since Previous",
  "19647db2fbfa": "mga hayop",
  "19ddafc12f92": "Tools Imbentaryo",
  "1a66279d9648": "https://…",
  "1a7b7c1b33d1": "Transaction",
  "1a9fa345cfd3": "Pakain Categories",
  "1bf3994417be": "Lokasyon:",
  "1c26dccca4ec": "Buwanang paggamit ng pakain:",
  "1c54132b8e5a": "Record",
  "1c5a564d4c4d": "Walang feed purchases yet",
  "1d0c73d85f54": "Warehouse Locations",
  "1e1856a908fb": "Item, SKU, supplier, lokasyon...",
  "1e5ff9e500c2": "Qty",
  "1e75cf7a0372": "Stock Movement Kasaysayan",
  "1eb4012ee2c9": "Bagong Births",
  "1ee3200b888b": "Mga value na pinaghihiwalay ng kuwit",
  "1f85f16afefa": "FCR",
  "201c869f726a": "Kalusugan Checks",
  "201cf44b6094": "Live na kabuuan ng feed stock, mga binili, konsumo, at babala.",
  "203b14a9d303": "Naglo-load animal records…",
  "2044b2d32473": "Gamot, equipment, tools, asset register, warehouse locations, stock history, and QR support in one live workspace.",
  "20e338624cee": "Assets",
  "22d5a3425998": "Magdagdag ng Hayop",
  "22dbc070acdf": "Pagbabakuna",
  "23101365c88a": "Tala Timbang",
  "232dc1368f6e": "Papuntang Lokasyon",
  "234d8d89d396": "Mga Araw ng Gestation",
  "237a3b253245": "Naglo-load growth records...",
  "246d291dae87": "Kabuuang Pakain",
  "257fe95db51c": "Walang timeline events yet.",
  "25b2f1c9237e": "Checklist ng Kahandaan sa Pagbenta",
  "25c278896313": "Walang animals available",
  "260ff50a7c28": "All Mga Hayop",
  "275a700078f0": "record",
  "2868023ccc42": "Itala ang kasalukuyang timbang at pakaing nakonsumo mula sa huling pagtimbang.",
  "2893ab3bd846": "Mga Tala ng Kalusugan",
  "295c43d41882": "Pinakabagong Timbang",
  "29bbaabc2052": "Acquisition Petsa",
  "2a6c6b93fb28": "Father (Sire)",
  "2bee5f4a4c10": "Walang movement history",
  "2d2a1342f45d": "Next Service Petsa",
  "2d812736dca6": "Every hayop from birth to sale — current life stage, sale readiness, health & mortality.",
  "2e123d865f03": "Pakain supplier names appear automatically from feed stock and purchase orders.",
  "2e71a937eb6d": "Kalusugan Inspections",
  "2ebeb6a45fe0": "Walang feed consumption records yet",
  "2ee750e04190": "Tip:",
  "2ee822bf17dd": "Mga Kapanganakan (Buwan)",
  "2eed73e61b10": "Gumawa ng Barcode",
  "2f4979324e03": "Kondisyon",
  "2f7b242e3a83": "Mga Species Preset",
  "300d29fd5f32": "Imbentaryo",
  "3030076c7bc2": "Walang feed movements yet",
  "304918a345d2": "Manager approve",
  "30c3a17c5a54": "Kabuuang records",
  "30c8a0fc9c1a": "Lahat ng uri",
  "325760e748ec": "Timbang Summary",
  "3281188351b8": "CSV",
  "3333d041a6de": "I-configure ang livestock fields para sa bawat species na lalabas sa animal form at profile records.",
  "33ce417454bf": "Naglo-load…",
  "33d9978c4477": "Mag-reorder",
  "33f147e5a87f": "e.g. spoilage, correction, transfer",
  "34290c48ee0b": "e.g. Buffalo, Turkey…",
  "3467859735eb": "Subaybayan dito ang tools, cleaning supplies, at consumable support stock.",
  "346c87feb190": "Breed:",
  "349ac8fb67f7": "Pumili…",
  "36155d48f460": "Equipment",
  "36da837e8b37": "Gamot",
  "3700890937a4": "Item *",
  "3703cd216881": "Kalusugan",
  "37dcaa9ab12f": "Dagdag/Bawas",
  "381c4bf1d409": "Alisin ang mga Filter",
  "382bc33f5991": "Kurba ng Paglaki",
  "394f35e11401": "M-Grandma",
  "395703d5f5b9": "Previous Timbang",
  "396c65e60e58": "Supplier *",
  "398658a601d9": "natitira",
  "3aa9bacb43a2": "Pakain Suppliers",
  "3b906ae77c48": "— None —",
  "3c40a44bb41f": "Pamamahala ng Imbentaryo",
  "3ca127a5a35d": "Subaybayan ang timbang, konsumo ng pakain, average daily gain, at feed-conversion ratio.",
  "3d0aa2fbc3ed": "I-save Weigh-in",
  "3d9f454fe3cd": "Option A, Option B",
  "3dcb2be9fa88": "Could not load Imbentaryo Management",
  "3deb74565196": "Uri",
  "3eb1b2e6c5fb": "Magdagdag ng medicine or vaccine items to start tracking storage, stock, and expiry.",
  "3f3a489c72de": "Lalaki",
  "3f3cc34fc78f": "hayop(s) under active treatment / observation.",
  "3f82cd24f99b": "Mga Natapos na Iskedyul",
  "3f87a11da0d1": "₱ / kg",
  "40aa5a2268dc": "Pakain deductions, receipts, and adjustments will appear here.",
  "40e64b44039a": "M-Grandpa",
  "4208adadecd9": "Target na timbang (kg)",
  "439e231109dc": "Order Petsa",
  "43aa47469f02": "Mga Natapos na Pagbabakuna",
  "43c8e26ef9d3": "Tala Consumption",
  "43e861b50e09": "Hayop QR Tag",
  "4426afd90a77": "Asset",
  "44d25b5d1b6d": "Mga Item",
  "44ef3f997add": "Gallery ng Larawan",
  "44f6af694554": "Dami",
  "4526beb53b60": "Sinusuri ang profile ng hayop...",
  "45e73b4ba97d": "Pakain Purchase",
  "45e7a1c379c7": "QR",
  "460faa8a18da": "Ang mga lokasyon ng imbakan ay kinukuha mula sa mga item record habang idinadagdag ang mga ito.",
  "46f9990edd2b": "Buksan ang Species Setup",
  "479ad150d354": "Tag ID *",
  "49181eaa9abb": "Walang animals match the current filters.",
  "493a215189e8": "Magdagdag ng farm assets to track status, condition, and service dates.",
  "49e21486cc6e": "Pamahalaan ang Species",
  "4a26dca78564": "Katayuan Breakdown",
  "4a9db9b99989": "Tala Weigh-in",
  "4bf117c4c02d": "Walang active animals in this species filter.",
  "4c669e0b6268": "Dami (kg)",
  "4c8f26e7117b": "Kulungan / Housing",
  "4cbdfa3a77db": "Pakain (kg)",
  "4d56ca9be0c8": "Mga Tala (opsyonal)",
  "4e579c31017e": "Mga nakatalang asset",
  "4e836fdc2572": "Manual",
  "4ec763aab4f8": "Feeding",
  "4f647c1b1ab2": "Bumalik sa Species",
  "4fa548ec107d": "Maghanap timeline events...",
  "4fa8cc860c52": "Tools",
  "5006ed0248a0": "event",
  "509e9a0f3232": "Walang active livestock notifications.",
  "512dad105fdd": "Dropdown Mga Opsyon",
  "51488472c352": "Tala consumption to update stock and cost tracking.",
  "515dd86c51f4": "Mga Pregnancy Check",
  "52526afc1060": "Kabuuang FCR",
  "5301648dcf6b": "I-edit",
  "5332fb07ad51": "All Imbentaryo Items",
  "534f84da47a2": "Talaan ng mga Hayop",
  "5397e0583f14": "Yes",
  "541c79d8906d": "Paglaki / Pagpapataba",
  "54bce5904e5b": "Pinagmulan Mga Opsyon",
  "54bf2f40c6da": "Buwanang paggamit ng gamot:",
  "5548ae4f34cb": "days",
  "55edd462872a": "Supplier",
  "55f9626c6c05": "Magdagdag ng Field",
  "56e3badc4e6c": "I-refresh",
  "57162c35dea4": "Pangalan*",
  "5755f9ac0aa1": "I-export sa CSV",
  "585c19860651": "AI Insight sa Breeding at Gestation",
  "58b9f51cadf2": "Pakain Runway & Reorder Insight",
  "58c0bd6ade68": "Gamitin ang lookup field upang mahanap ang inventory item o asset ayon sa code o pangalan.",
  "59bba0608a3c": "Susunod na Due / Follow-up",
  "59ef31e37acc": "Antas ng Reorder",
  "5b221e9c2a45": "I-print",
  "5b4a40f54485": "Farrowing",
  "5b779ea02219": "Payagan ang negatibong stock (owner/admin lamang)",
  "5b83c8c1f5d4": "Medical Timeline Mga Tala",
  "5baa9155c930": "Pakain Cost Tracking",
  "5bdd5c241b30": "Kapanganakan hanggang Benta",
  "5c173ef78781": "Pumili species",
  "5c5ad63cd148": "Magdagdag ng Gestation",
  "5cbf60902ee2": "Gestation",
  "5d08f9511d95": "Rows:",
  "5d1b80121622": "Monthly Pakain Cost",
  "5d6b50bb295d": "Dagdag Mula sa Nakaraang Timbang",
  "5dde525d8086": "Kabuuang Hayop",
  "5e5837db8186": "Kabuuang Gain",
  "5fb4a01bf140": "Gastos / Unit",
  "6051a9526ec0": "mga tala for this species.",
  "6083e706b22f": "Piglet / Young",
  "60f1e913db61": "Hindi tinukoy",
  "6149ff653a46": "Arawang Dagdag na Timbang",
  "61b5b59fbab8": "Offspring (",
  "61cc55aa0453": "Magdagdag",
  "62096e1d4d84": "P-Grandma",
  "6405179d241b": "Lahat ng katayuan",
  "64257ac78d08": "Mga Label ng Lokasyon",
  "6451a93db098": "Vet visit",
  "64ae43e8fe76": "Gastos",
  "64b69a9e55a0": "Pen, pond, coop, cage…",
  "6527e706017d": "ADG",
  "6600f853ec41": "Yugto ng Produksyon",
  "67a6ff10f1b9": "Nakareserba",
  "68309f127cb6": "Hindi Pinayagan ang Paglipat",
  "687c82861c95": "Mga Dokumento",
  "699edf83caae": "Mga Hadlang",
  "69bd4ef9fbd0": "Tingnan",
  "69c0b81540bd": "Timbang",
  "6ad8acc1a379": "Imbentaryo ng Gamot",
  "6b7c0218276d": "Sex Mga Opsyon",
  "6bccca646f67": "Ibinawas",
  "6c7dc36d0d76": "Mga Medikal na Babala",
  "6da13addb000": "Pinagmulan",
  "6e48b29888d5": "Mga Opsyon sa Lahi",
  "6e6a6f2086bb": "Iba pa",
  "6eef6648406c": "Wala",
  "6f62975f8e77": "Average Timbang",
  "7015ab4fc4ea": "Paghahanap",
  "70440046a3dc": "Mga Tala",
  "709a23220f2c": "Pangalan",
  "70b6f53fbdf9": "Walang weigh-ins yet for this animal. Click \"Tala Timbang\" to start tracking.",
  "716f63b96e0c": "Icon",
  "7175a9fe5560": "Purchase orders and receiving flow for feed suppliers.",
  "71ae2e313d19": "I-save Field",
  "71d6ab175c7f": "Animal ID",
  "72190121658b": "Kasalukuyang Timbang (kg)",
  "725bc458ce08": "Kahandaan sa Pagbenta",
  "725d63c76780": "Gumawa ng stock ng gamot, equipment, o tool upang magsimulang mag-track.",
  "73656b6dcc12": "Presyo / kg",
  "7389b3b752fa": "Hayop",
  "74341e3c271d": "Label",
  "7451228fe603": "Awtomatikong gagawin kapag blangko",
  "7477762fadeb": "Gumamit ng negatibong bilang para sa pagbabawas",
  "747876156da0": "Gastos sa Pagbili",
  "76e4488c60b0": "Kabuuang value:",
  "77074b7e37f0": "Mga Abiso sa Livestock",
  "777c078c9b7b": "Lahi",
  "7794d275d6c6": "Magdagdag ng Pregnancy Check",
  "77dfd2135f4d": "Kanselahin",
  "780b2eb08d06": "Walang events match your filters.",
  "78b819622818": "Bagong Item",
  "797a4917230e": "Lahat ng lokasyon",
  "79ec1b992c03": "Itala ang konsumo upang ibawas sa stock at subaybayan ang gastos sa pakain kada kg.",
  "7ac5949949ba": "Bagong Species",
  "7b83bbb85e1b": "Tala Stock Transaction",
  "7b95b5178611": "Mga Bakuna",
  "7cc6e4582b56": "Walang photos linked.",
  "7cd5b9ea84fa": "Field Key",
  "7d7bb74219c3": "Breeding Stock",
  "7d9252d939e7": "Equipment Imbentaryo",
  "7db486db207f": "Gumawa ng QR",
  "7e5a975b6add": "Identity",
  "7e8892b35c5f": "Pumili an item or asset",
  "7ec2484371b6": "Pagkamatay (Buwan)",
  "7f606a9b1522": "Walang medicine inventory",
  "80029aac6ba4": "Magdagdag ng Deworming",
  "80e519ac864e": "Buwanang Dagdag na Timbang",
  "816c52fd2bdd": "No",
  "83800502d070": "Naglo-load feed inventory...",
  "83a56249e5cf": "Kalakip",
  "83a7238826ab": "Species",
  "84d296628caf": "Inaasahang Petsa",
  "84dfdb55f9e6": "URL ng Larawan",
  "86b217fdcad3": "Batch Number",
  "87398e24ea58": "Kalusugan checks",
  "88bc3fe3dadd": "Mga Ulat",
  "896a4e836ceb": "Imbentaryo ng Pakain",
  "8a7e05ab4689": "Could not load Pakain Imbentaryo",
  "8ac44bc6683d": "Read-only na talaan ng asset",
  "8b42192e439b": "Universal Livestock",
  "8b7cad5bca5b": "Ginagamot",
  "8b8331402853": "Walang feed stock yet",
  "8bf1ef5668b1": "Batch",
  "8c603960eb2f": "Walang species yet.",
  "8d007050838a": "Petsa ng Expiry",
  "8dce170de238": "Halaga",
  "8df6fbb79f88": "Mga Babala sa Expiry",
  "8f210c7b2cfe": "Ang hayop na ito",
  "8f57e24b53b0": "Gestation (days)",
  "8fabfed883f0": "Imbentaryo Barcode",
  "8fba6b663578": "Susunod na Serbisyo",
  "9020d87d6a1d": "Walang species configured yet",
  "90fb871e3532": "Mga lokasyon ng warehouse",
  "911f3b0b4732": "Ililipat mo ang hayop na ito sa",
  "915586ea1401": "Detalye ng Gastos",
  "9277a4e58ef5": "Magdagdag ng Breeding",
  "92928c7b6205": "Walang rows for this report.",
  "92a72cdc19c4": "Pumili stage",
  "931b0211b3e6": "Pinakamababang Stock",
  "931cd0b708ee": "Kasalukuyang Timbang",
  "93ccf8886685": "Dito makikita ang receiving, bawas sa pagpapakain, at manwal na adjustment.",
  "965fb2ddf63d": "Receive",
  "96f84c4f4b2d": "Animal ID / Tag",
  "97c89a4d6630": "Aksyon",
  "9815c7072808": "Pumili ng hayop",
  "982963c1c41c": "Tag",
  "98e5ef062b2a": "I-download ang PDF",
  "995d09d416ac": "Tala Pakain Consumption",
  "9978c7eb8d75": "Walang birth record linked to this animal.",
  "9a4352f7fb4a": "Walang assets registered",
  "9ae2c512e27d": "Walang equipment inventory",
  "9afdc0c98e0e": "Uri ng Transaksyon *",
  "9c3befe7e22c": "Notes:",
  "9c59b3b940b8": "Walang inventory items",
  "9cc46760be1f": "checks passed",
  "9d2c70630887": "Pagkakakilanlan",
  "9daa9201229d": "Gastos/Unit",
  "9df4ffaba1bc": "Suriin ang mga Babala",
  "9e883160f12a": "araw ang edad",
  "9f5cd8a2e880": "Subukan Muli",
  "9fdae79fc41c": "Could not load Hayop Registry",
  "a05f378cba73": "Mga Bakunang Due",
  "a08e11119aef": "Excel",
  "a10cf6a84db4": "Walang category data available.",
  "a124947cbd2d": "Low",
  "a225c8ebcac0": "Lokasyon ng Imbakan",
  "a29d47a9717b": "Pakain Purchases",
  "a3081da3685d": "Gumawa ng purchase order para sa dagdag na pakain at tanggapin ito sa stock.",
  "a3c686e711e4": "Kategorya",
  "a3f812e5f85c": "I-save Transaction",
  "a4cbd21f4a3d": "Pagbabago",
  "a65de8bce998": "Nakatakdang Lugar",
  "a689a999a5e6": "Expired",
  "a6989f1caddd": "Petsa ng Kapanganakan",
  "a6e1fef14e1b": "Mababang stock",
  "a733b809d2f1": "Aktibo",
  "a7502c1c8415": "Ina (Dam)",
  "a7fc7eb3b9ba": "Resulta ng Paghahanap",
  "a9001c7bea7d": "AI advisory only. Verified inventory mga tala, stock deductions, runway calculations, and reorder rules remain authoritative.",
  "a91f9527fb14": "Walang animals yet. Magdagdag ng your first!",
  "aa68ea8175f6": "Maghanap gamit ang SKU, pangalan ng item, asset QR, o pangalan ng asset",
  "aada71c46f1c": "Walang feed batches yet",
  "ac5932b6433e": "Buod ng Operasyon",
  "ad43a5186744": "Magdagdag ng Species",
  "ad87109bfff0": "empty",
  "ada52d888ccf": "Sources:",
  "ae0433b83254": "Pregnant Mga Hayop",
  "ae2279147e20": "Maghanap gamit ang animal ID, tag, lahi, o species…",
  "ae65324b857d": "Farm Operations",
  "aebda3645d67": "Pumili feed item",
  "aee5f633d5df": "Kg",
  "af59c1b5032c": "I-save Pakain Purchase",
  "afda12b73a18": "Magdagdag ng a feed stock item and assign a category to begin grouping inventory.",
  "afe080d91852": "Walang tools inventory",
  "b0025fcfba1a": "I-print ang Tag",
  "b04ba49f8486": "Naglo-load...",
  "b0946c471bef": "Pumili item",
  "b19f1a5a771a": "Stock ng Pakain",
  "b2107cb53b71": "Maaari mong tingnan ang asset register, ngunit kailangan ng settings permission upang mag-edit.",
  "b2537e92cedd": "· reorder",
  "b25928c69902": "Kabuuang",
  "b25db9c91647": "ADG (kg/day)",
  "b298bc6a9e73": "Mga Bakunang Due",
  "b2d28451f2ac": "Imbentaryo consumption:",
  "b37bfabd815c": "Pindutin ang species upang makita ang dashboard, records, inventory, sales, at health nito.",
  "b452abc00d55": "Mga Babala sa Mababang Stock",
  "b5d8da40f3ed": "Kabuuang Cost",
  "b6321aaca189": "Uri ng Field",
  "b6a5b27dc1c9": "Kasalukuyang feed stock value",
  "b7c17e97d3d6": "Babae",
  "b7caebb3a0d2": "Walang photo",
  "b7f1480271f7": "Paglaki at FCR",
  "b8273ffd22de": "Mga Paparating na Iskedyul",
  "b8fde823cc69": "Kategorya ng Pakain",
  "b92e64f8b332": "Pumili...",
  "b9379d305ca4": "Pakain Consumption",
  "b953668f0a6d": "Inaprubahan ni",
  "b98d67213b38": "Malapit Mag-expire",
  "b9b664eafeff": "Performance ng Livestock",
  "ba30f581b71a": "Walang feed categories yet",
  "ba8f571e0f93": "Expiry",
  "bae7d5be7082": "Katayuan",
  "bb4b09092c7b": "Handa nang Ibenta",
  "bb6b3d02e567": "I-filter ayon sa species",
  "bb98ca672621": "Preview ng QR",
  "bbfa773e5a63": "Isara",
  "bc08c8ca11eb": "Naglo-load species and animals...",
  "bc23d3365489": "Recent Pakain Movements",
  "bc2bbcfd991a": "Mga aktibong kaso",
  "bc67a8aefae6": "Walang Stock",
  "bce06414177f": "Maghanap",
  "bcecf4562f17": "Stock",
  "be2218931154": "Mag-upload ng mga Dokumento",
  "be52964f94d6": "Isang configurable na sistema para sa baboy, baka, poultry, isda, alagang hayop, bubuyog, at custom species.",
  "c0d66da0ed20": "but sale-readiness checks are failing:",
  "c0f789c54889": "Magdagdag ng Bakuna",
  "c195df524d2c": "Paglaki / Finishing",
  "c26b31168973": "Kabuuang Production Cost",
  "c3cd636a585b": "Mga Aksyon",
  "c40810f5c31d": "Mabilisang Aksyon",
  "c425df01c7ec": "Maghanap tag, name, breed...",
  "c4506f67727e": "Ituloy pa rin ang paglipat",
  "c500690deb24": "Lahat ng species",
  "c63acbcc4830": "Katayuan Options",
  "c6cdc5b935cb": "I-save Species Config",
  "c813d87308e6": "Daloy ng Livestock",
  "c81b853cafb4": "Item sa Imbentaryo",
  "c8899e40dced": "I-save Pakain Stock",
  "c9411ae8d103": "Handa nang Ibenta",
  "ca567dda33cd": "Code:",
  "ca6d0e3aaa7d": "Stage",
  "cd8c2df26c59": "Gamot",
  "cded093321dd": "Mga Order",
  "ce31372bab62": "Sale-Readiness",
  "cf6c07e7054f": "Pen",
  "cfadbd7a5771": "By",
  "d03becf78c55": "e.g. Started new feed formula",
  "d07a4554e6f9": "Naglo-load report...",
  "d0940f026be6": "Magdagdag ng Gamot",
  "d0edfb6e8c55": "Sales",
  "d0efe0b2c75c": "Mga Babala",
  "d145bb830936": "Pangalan *",
  "d17858483509": "Mga Alagang Hayop",
  "d219c68101f5": "Lokasyon",
  "d24983206285": "Timbang (kg)",
  "d356631d4242": "Talaan ng Asset",
  "d43c8e6c0c7e": "Employee/User",
  "d53879f401fe": "Weight:",
  "d59192b9c8f2": "SKU",
  "d613d88cb2d8": "PDF",
  "d65ae9967727": "QR / Barcode",
  "d6dadec06672": "Receipts",
  "d758262e8fe0": "Naglo-load inventory management...",
  "d7d33a37498a": "Pakain Mula sa Huling Pagtimbang (kg)",
  "d82998b02298": "Walang match yet",
  "d87f47b47e4d": "Dashboard",
  "d8b4d943f628": "Configuration ng Species",
  "d8b795f1caa9": "Sentro ng mga Alagang Hayop",
  "d8c57bebe4be": "Kamakailang Konsumo",
  "d96f52b84799": "Imbentaryo Value",
  "dab547ca0781": "Mga Iskedyul na Lampas na sa Due",
  "db3d405b1067": "on",
  "db772d77f026": "Pakain Batches",
  "dcbe6782d317": "Buwanang gastos sa pakain",
  "dcf09d387818": "Sold (Month)",
  "dd5f667597ac": "Stock by Kategorya",
  "decd7ca80010": "Pinakabago",
  "df4ebc16e8c5": "Batch / Expiry",
  "df9c88127462": "Pagpupurga",
  "e0a94b30808d": "Walang custom fields for this species yet.",
  "e154cb584579": "Target Timbang",
  "e1d599cca0a1": "Magdagdag ng at least one species before creating animal records.",
  "e1dee3f10e02": "Mula sa Lokasyon",
  "e301dd6062f7": "Kasarian",
  "e3c2f30bf6f0": "Timbang Progress",
  "e49000cd16ad": "Walang preview",
  "e51c55255be9": "Mga Tala",
  "e57310bd5fa4": "Mag-iskedyul ng Pagbabakuna",
  "e5af0395ec56": "Sex:",
  "e6560d9c298e": "Sold",
  "e82e5b2a7359": "Mga tala ng galaw",
  "e838aabe4ef1": "Pakain Item *",
  "e997447a5ce9": "Lokasyon ng Warehouse",
  "e9da79148e64": "Mga due / follow-up na babala",
  "e9fd92ae6da3": "Pakain categories, suppliers, purchases, batches, stock, consumption, and live alerts in one production view.",
  "ea0e082d4d4b": "I-save Item",
  "ea43c011ff1e": "Subaybayan dito ang equipment parts at replacement stock.",
  "ea8cd0b9a0bd": "Mag-iskedyul ng Paggamot",
  "eb9a4bc1c0c1": "Petsa",
  "ecdda59aea5e": "Item",
  "ed8cb2617ecd": "Magdagdag ng Farrowing",
  "ee45c30326b7": "Report",
  "eebf5dd44b08": "Walang weight measurements yet.",
  "eed6bfb41051": "Kinakailangan",
  "ef2c495072dd": "Bagong Timbang",
  "ef3b54d66fd8": "Magdagdag ng Pagbisita ng Beterinaryo",
  "f13fa3438318": "Namatay",
  "f20905eeec4b": "Gumawa ng unang feed inventory item upang masimulang subaybayan ang stock at konsumo.",
  "f219cc0614ae": "Dahilan",
  "f22e1c3983ce": "Bagong Pakain Stock",
  "f28563a477a9": "Colour",
  "f2c6b564bd81": "Seksyon",
  "f32eebfabdfe": "Mga tala ng konsumo",
  "f4d52fad548f": "Kabuuang Alive",
  "f4ec66c8df43": "Gestation:",
  "f50d3e648add": "Kasalukuyang feed items, batch details, stock levels, and costs.",
  "f588d982d308": "Hati Ayon sa Species",
  "f6b935ab3371": "Unit",
  "f6ce3b6fcfca": "Receipt",
  "f6d8dc2e9c7a": "Expiry Alerts",
  "f6fdbe48dc54": "Tanggalin",
  "f76d1e2a5054": "Inilipat",
  "f7aaca979af6": "Buod ng Stock",
  "f9096ddd8468": "Magdagdag ng Health Check",
  "f93f25f348f3": "Breeding",
  "f967a88e008c": "Walang suppliers yet",
  "f97872e1cdbb": "P-Grandpa",
  "f9c10dfc68e6": "🤖 AI Insight",
  "fbfb66c84913": "Pagkamatay",
  "fc78ebe76aec": "Pakain Name *",
  "fcf1dded7a2a": "With media",
  "fd3bc9709730": "Buod na naka-link sa backend",
  "fe5220666fae": "Kulungan / Lokasyon",
  "ff18d709fc9e": "Pakain items",
  "ff1928e5d29b": "Pakain",
  "ff4fc0276e96": "Profile",
  "ffc91ed29d9d": "I-save Asset"
};
